import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { breakpoints } from 'utils/breakpoint';
import { setIsSmallScreenApp } from 'client/redux/modules/appState';

export default function useListenSmallScreen() {
    const dispatch = useDispatch();
    const isSmallScreen = useMediaQuery(`(max-width:${breakpoints.sm}px)`);

    useEffect(() => {
        dispatch(setIsSmallScreenApp(isSmallScreen));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSmallScreen]);
}
